module.exports = __webpack_public_path__ + "img/coaching.f8ce1a6c.svg";